<template>
    <div id="featureDualParallaxVerticalScrollRoot">
        <div id="container">
            <div id="leftContainer">
                <div :style="leftContainerScroll">
                    <div id="image1" class="imageSmall">
                        <img
                                src="../../assets/ic_julio_share.svg" @contextmenu.prevent/></div>
                    <div id="image2" class="imageSmall">
                        <img
                                src="../../assets/ic_julio_console.svg" @contextmenu.prevent/></div>
                    <div id="image3" class="imageSmall">
                        <img
                                src="../../assets/ic_julio_rate.svg" @contextmenu.prevent/></div>
                    <div id="image4" class="imageSmall">
                        <img
                                src="../../assets/ic_julio_share.svg" @contextmenu.prevent/></div>
                    <div id="image5" class="imageSmall">
                        <img
                                src="../../assets/ic_julio_console.svg" @contextmenu.prevent/></div>
                </div>
            </div>


            <div id="middleContainer">
                <FeatureInfoContainerCard v-on:is-expanded="toggle" :open-icon-position="iconPosition"
                                          background-color="#FAFAFA">
                    <div id="content" :style="containerHeight">
                        <transition name="fade" mode="out-in">
                            <div v-if="!expanded" :style="titleColor" id="title"><span
                                    v-html="content[0].title"></span>
                            </div>
                        </transition>
                        <transition name="fade" mode="out-in">
                            <div v-if="!expanded" id="description"><span v-html="content[0].description"></span>
                            </div>
                        </transition>
                        <transition name="fade" mode="out-in">
                            <div v-if="expanded" id="expandedDescription">
                                <span v-html="content[0].expandedDescription"></span>
                            </div>
                        </transition>
                    </div>
                </FeatureInfoContainerCard>
            </div>


            <div id="rightContainer">
                <div :style="rightContainerScroll">
                    <div id="rightImage" class="imageSmall">
                        <img src="../../assets/julio_typography.svg" @contextmenu.prevent/></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FeatureInfoContainerCard from "./FeatureInfoContainerCard";

    export default {
        name: "FeatureDualParallaxVerticalScrollCard",
        components: {FeatureInfoContainerCard},
        props: {
            height: {
                type: Number,
                default: 0
            },

          name: {
            type: String,
            default: ""
          },
          description: {
            type: String,
            default: ""
          },
          taglineDescription: {
            type: String,
            default: ""
          },
          tagline: {
            type: String,
            default: ""
          },
          content: {
            type: Array,
          },
        },
        data() {
            return {
                expanded: false
            }
        },
        computed: {
            offset() {
                return this.$store.state.scrollOffset
            },
            titleColor() {
                return {color: '#37474F'}
            },
            iconPosition() {
                if (this.height > 812)
                    return 3
                else
                    return 1
            },
            leftContainerScroll() {
                return {
                    transform: `translateY(${this.position(this.offset)}%)`
                }
            },
            rightContainerScroll() {
                return {
                    transform: `translateY(${this.rightPosition(this.offset)}%)`
                }
            },
            containerHeight() {
                if (this.expanded)
                    return {
                        'height': `100%`
                    }
                else
                    return {
                        'height': `100%`
                    }
            }
        },
        methods: {
            toggle(value) {
                this.expanded = value
                this.$gtag.event('featureToggle', {
                    eventCategory: 'type_system',
                    eventAction: 'click',
                    eventValue: value ? 1 : 0
                })
            },
            position(val) {
                let position = 0;
                if (this.height > 812)
                    position = (val - (this.height * 5));
                else if (this.height <= 812)
                    position = (val - (this.height * 2.6));
                return position / 80;
            },
            rightPosition(val) {
                let position = 0;
                if (this.height > 812)
                    position = (val - (this.height * 3.8));
                else if (this.height <= 812)
                    position = (val - (this.height * 6.9));
                return -position / 60;
            },
        }
    }
</script>

<style lang="scss" src="../../styles/featureDualParallaxVerticalScrollCard.scss" scoped/>